export enum ActiveType {
  _TUG = 'Timed Up and Go Test',
  _6MWT = '6 Metre Walk Test',
  _10MWT = '10 Metre Walk Test',
  _BT = 'Balance Test',
  _CTEST = 'Custom Test',
}
